import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../components/Helpers/helpers";

export const roleApi = createApi({
  reducerPath: "roleApi",

  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),

  tagTypes: ["Roles"],

  endpoints: (builder) => ({
    // GET ROLE LIST - ORGANISATION WISE
    getRoleList: builder.query({
      query: ({ OrganisationID, UserId }) => ({
        url: `/role?OrganizationID=${localStorage.getItem("OrganisationID")}&UserId=${UserId}`,
        method: "GET",
        params: {
          OrganisationID,
          UserId,
        },
      }),

      transformResponse: (response) => {
        return {
          data: response.data || [],
          message: response.message,
          isAdmin: response.isAdmin || false,
          allAccess: response.allAccess || false,
        };
      },

      providesTags: ["Roles"],
    }),

    // DELETE ROLE
    deleteRole: builder.mutation({
      query: ({ id, OrganisationID }) => ({
        url: `/role/delete/${id}`,
        method: "DELETE",
        body: {
          OrganisationID,
        },
      }),

      invalidatesTags: ["Roles"],
    }),
  }),
});

export const { useGetRoleListQuery, useDeleteRoleMutation } = roleApi;
